import cls from 'classnames'
import React, { Component } from 'react'
import style from '../style.module.less'

export default class extends Component {
  render() {
    const {
      item: { icon, title },
      isActive,
      isMenuSelected,
      ...rest
    } = this.props

    return (
      <a
        className={cls(style.menu, {
          [style['menu-active']]: isActive,
          [style['menu-selected']]: isMenuSelected
        })}
        {...rest}
      >
        {icon && <i className={`iconfont ${icon}`} />}

        <span>{title}</span>
      </a>
    )
  }
}
